/**
 * Prospects page events, for PRD §14's measures: how many connected advisors open the list weekly, and
 * Tier 1 precision by thumbs-up rate.
 *
 * The events table is shared across every tenant, and PRD §9 bars pooling anything derived about
 * people who have not consented. So these carry no prospect id, name or count — only what the advisor
 * did, the model version, and the tier of the one prospect acted on.
 */
import { analytics } from '@client/analytics';
import type { Prospecting } from '@client/api/types';

const CATEGORY = 'engagement';

export function trackProspectListOpened(modelVersion: string): void {
  analytics.track('prospect_list_opened', { modelVersion }, CATEGORY);
}

export function trackProspectPanelOpened(tier: Prospecting.Tier, modelVersion: string): void {
  analytics.track('prospect_panel_opened', { tier, modelVersion }, CATEGORY);
}

export function trackProspectFeedback(
  vote: Prospecting.FeedbackVote,
  reasonCode: string | null,
  tier: Prospecting.Tier,
  modelVersion: string,
): void {
  analytics.track('prospect_feedback', { vote, reasonCode, tier, modelVersion }, CATEGORY);
}
